import 'reflect-metadata';

export function isInjectable(module: any) {
    if (module == undefined)
        return false;

    return Reflect.getOwnMetadata('inversify:tagged', module) != undefined;
}